import React from 'react';
import { Link } from 'react-router-dom';

export const BRAND = {
  name: '追焦',
  latinName: 'ZHUIJIAO',
  slogan: '不经意的瞬间，值得好好珍藏',
  englishSlogan: 'Every journey, your story.',
} as const;

/**
 * 品牌 wordmark：CSS mask 方式，颜色由 var(--accent) 控制，随主题切换自动变色。
 * SVG 作为 mask 只取 alpha 通道，实际颜色由 background-color 决定。
 */
export function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className="brand" aria-label={`${BRAND.name} ${BRAND.latinName} 首页`}>
      <span className="brand-wordmark" role="img" aria-label={`${BRAND.name} ${BRAND.latinName}`} />
    </Link>
  );
}
